import { render } from "./TheHomeButtom.vue?vue&type=template&id=9eb641c8"
import script from "./TheHomeButtom.vue?vue&type=script&lang=ts"
export * from "./TheHomeButtom.vue?vue&type=script&lang=ts"
script.render = render

export default script